import { Deserializable } from '../deserializable';
import { BusinessResponseDTO } from '../register-form/business-response-dto/business-response-dto';
import { Equipment } from '../register-form/equipment/equipment';
import { Representative } from '../register-form/representative/representative';
import { BusinessDTO } from '../requests/business-dto/business-dto';

/**
 * Account to register
 */
export class Account extends Deserializable {
  /**
   * @constructor
   */
  constructor(
    public business: BusinessResponseDTO | BusinessDTO,
    public equipments: Equipment[],
    public representative: Representative
  ) {
    super();
  }
}
